/**
 * @file Deterministic loaded-data sort helpers for Ordering cards.
 */

function toMillis(value) {
    if (typeof value?.toMillis === "function") {return value.toMillis();}
    const seconds = typeof value?.seconds === "number" ? value.seconds : value?._seconds;
    const nanoseconds = typeof value?.nanoseconds === "number" ?
        value.nanoseconds : (value?._nanoseconds || 0);
    if (typeof seconds === "number") {return (seconds * 1000) + (nanoseconds / 1e6);}
    if (value instanceof Date) {return value.getTime();}
    const parsed = Date.parse(value || "");
    return Number.isFinite(parsed) ? parsed : 0;
}

function compareText(left, right) {
    return String(left || "").localeCompare(String(right || ""), undefined, {
        sensitivity: "base",
    });
}

/**
 * Sorts active Ordering items by the approved deterministic display order.
 * @param {object} left First item.
 * @param {object} right Second item.
 * @returns {number} Comparator result.
 */
export function compareActiveOrderingItems(left, right) {
    const leftDated = Boolean(left?.due_date);
    const rightDated = Boolean(right?.due_date);
    if (leftDated !== rightDated) {return leftDated ? -1 : 1;}
    if (leftDated && left.due_date !== right.due_date) {
        return compareText(left.due_date, right.due_date);
    }
    const updatedDiff = toMillis(left?.updatedAt) - toMillis(right?.updatedAt);
    if (updatedDiff !== 0) {return updatedDiff;}
    const nameDiff = compareText(left?.name, right?.name);
    return nameDiff || compareText(left?.id, right?.id);
}

/**
 * Sorts loaded closed history newest first with document-ID stability.
 * @param {object} left First item.
 * @param {object} right Second item.
 * @returns {number} Comparator result.
 */
export function compareClosedOrderingItems(left, right) {
    const updatedDiff = toMillis(right?.updatedAt) - toMillis(left?.updatedAt);
    return updatedDiff || compareText(right?.id, left?.id);
}
